/* tslint:disable */
/* eslint-disable */
/**
 * Nightingale API
 *  ### Welcome to the Nightingale API !   To use the Nightingale API, you will need a `access_token` from **Bridgetech Support**  ## How to use swagger documentation   Click `Authorize` and paste your  `access_token` as `bearerAuth`  ## Design Notes 1. For non-mandatory fields, the API will allow you to submit `null` *or* omit fields entirely. 2. All query parameters are optional. Pagination fields default as follows: * page = 1 * limit = 20
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const Role = {
    NgUser: 'ng_user',
    NgSystemAdmin: 'ng_system_admin',
    NgSupervisor: 'ng_supervisor',
    NgServiceAccount: 'ng_service_account'
} as const;
export type Role = typeof Role[keyof typeof Role];


export function instanceOfRole(value: any): boolean {
    for (const key in Role) {
        if (Object.prototype.hasOwnProperty.call(Role, key)) {
            if (Role[key as keyof typeof Role] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RoleFromJSON(json: any): Role {
    return RoleFromJSONTyped(json, false);
}

export function RoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): Role {
    return json as Role;
}

export function RoleToJSON(value?: Role | null): any {
    return value as any;
}

export function RoleToJSONTyped(value: any, ignoreDiscriminator: boolean): Role {
    return value as Role;
}

